import {sendAnalyticPayload, AnalyticEvent} from '../utils/analytic';

export const useSendSurveyResultAnalytic = (
  model: string,
  postCode: string,
) => {
  const handleMapLoad = () => {
    sendAnalyticPayload(
      {
        configuration: {
          ModelName: model,
        },
        user: {
          LocationZIP: postCode,
        },
        process: {
          Name: 'ChargingMap',
          StepName: 'Charging Map Load',
          StepNumber: '1',
        },
      },
      AnalyticEvent.VWBasicVehicleStepLoad,
    );
  };

  const handleMapSearchLocation = (
    searchTerm: string,
    numberOfResults: number,
  ) => {
    sendAnalyticPayload(
      {
        configuration: {
          ModelName: model,
        },
        user: {
          LocationZIP: postCode,
        },
        search: {
          SearchTerm: searchTerm,
          NumberOfResults: numberOfResults,
        },
        process: {
          Name: 'ChargingMap',
          StepName: 'Charging Map Results',
          StepNumber: '2',
        },
      },
      AnalyticEvent.VWBasicVehicleStepLoad,
    );
  };

  const handleSelectChargingStation = (
    stationName: string,
    stationPostcode: string,
    searchTerm: string,
    numberOfResults: number,
  ) => {
    sendAnalyticPayload(
      {
        configuration: {
          ModelName: model,
        },
        user: {
          LocationZIP: postCode,
        },
        partner: {
          InformationName: stationName,
          InformationZIP: stationPostcode,
          SearchTerm: searchTerm,
          NumberOfResults: numberOfResults,
        },
        process: {
          Name: 'ChargingMap',
          StepName: 'Charging Location Selected',
          StepNumber: '3',
        },
      },
      AnalyticEvent.VWBasicVehicleStepLoad,
    );
  };

  const handleCTAClick = () => {
    sendAnalyticPayload(
      {
        process: {
          Name: 'ChargingMap',
          StepName: 'Get Directions',
          StepNumber: '4',
        },
        link: {
          name: 'Get Direction',
        },
      },
      AnalyticEvent.CTAClick,
    );
  };

  return {
    handleMapLoad,
    handleMapSearchLocation,
    handleSelectChargingStation,
    handleCTAClick,
  };
};
